export const ORDERS_LIST = "ORDERS_LIST";
export const ORDERS_LIST_FAILED = "ORDERS_LIST_FAILED";
export const ORDERS_LIST_SUCCESS = "ORDERS_LIST_SUCCESS";

/***** order Detail Action *****/
export const ORDERS_DETAIL = "ORDERS_DETAIL";
export const ORDERS_DETAIL_FAILED = "ORDERS_DETAIL_FAILED";
export const ORDERS_DETAIL_SUCCESS = "ORDERS_DETAIL_SUCCESS";